import { render, staticRenderFns } from "./stars.vue?vue&type=template&id=8b92343e&"
import script from "./stars.vue?vue&type=script&lang=js&"
export * from "./stars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b92343e')) {
      api.createRecord('8b92343e', component.options)
    } else {
      api.reload('8b92343e', component.options)
    }
    module.hot.accept("./stars.vue?vue&type=template&id=8b92343e&", function () {
      api.rerender('8b92343e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/stars.vue"
export default component.exports